export const APP_VERSION = "3.0.1";
export const APP_NAME = "Sisbagal";
export const FULL_APP_NAME =
    "Sistema de información de servizos básicos de augas de Galicia";
